import React from "react";
import ajax from "./../lib/ajax.js";
import context from "./../lib/context.js";
import {Redirect, browserHistory} from "react-router";
import Immutable from "immutable";
import HistoryTCClockEdit from "./history-tc-clock-edit.jsx";
import HistoryTCDuration from "./history-tc-duration.jsx";

export default class HistoryTCEntry extends React.Component {    
    constructor(props) {
        super(props);
        this.state = {
            timecardType : null
        }
    }

    componentDidMount() {
        const self = this;
        const tid = this.props.params.timecardId || "";
        console.log(tid);
        ajax.api()
        .get(`people/tc-type/${tid}`)
        .then(function(res) {
            const result = res.data;
            self.setState(Immutable.fromJS(self.state)
                                   .mergeDeep({timecardType : result})
                                   .toJS());
        });
    }

    render() {
        const content = this.state.timecardType === "CLOCKTC" || this.state.timecardType === "CLOCKEDITTC" ?
            <HistoryTCClockEdit location={this.props.location} params={this.props.params} 
                route={this.props.route} routes={this.props.routes} durationTcRoute="people/history-tc-entry/:timecardId"/> : 
        this.state.timecardType === "DURATIONTC" ? 
            <HistoryTCDuration location={this.props.location} params={this.props.params} 
                route={this.props.route} routes={this.props.routes} clockeditTcRoute="people/history-tc-entry/:timecardId"/> : null;
        return (<div>
            {content}
        </div>);
    }
}